import React from "react";
import photoUrl from "../assets/img/treatments/TattooRemoval.JPEG";
import {
  rejuviPreCare,
  rejuviRightAfterTreatment,
  rejuviFirst72Hours,
  rejuviDays4to7,
  rejuviDays8to14,
  rejuviWeeks3Plus,
  rejuviDosDonts,
} from "../data/preCareInstructions";

const RejuviTattooRemovalCare = () => {
  return (
    <>
      <h1 className="md:text-5xl text-3xl justify-center flex my-8 m-auto p-2">
        Rejuvi Tattoo Removal Care
      </h1>

      <div className="flex flex-col-reverse md:mx-12 my-8 lg:flex-row flex-wrap items-start">
        <div className="w-full lg:w-3/5 pr-4 my-8 lg:mb-0">
          <div className="mb-6 p-8 ">
            <h2 className="md:text-3xl text-xl font-semibold mb-8 text-black">
              Rejuvi Tattoo Removal Pre + Post Care
            </h2>
            <p className="text-base leading-loose text-gray-800 lora-font">
              The Rejuvi tattoo removal system uses a controlled crusting process to safely 
              extract unwanted pigment from your skin. Following proper pre and post-care 
              instructions is essential for optimal results and healing. The process is 
              non-laser and designed to lift pigment while preserving skin integrity.
            </p>
          </div>
        </div>
        <div className="w-full lg:w-2/5 p-4 md:p-0 md:pl-4 md:my-8 lg:mb-0">
          <img
            src={photoUrl}
            alt="Rejuvi Tattoo Removal"
            className="rounded-lg shadow-lg w-[600px] h-[400px] object-cover mx-auto lg:mx-0"
          />
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg">
          <div className="flex flex-col-reverse lg:flex-row flex-wrap items-start">
            <div className="w-full pr-4 mb-8 lg:mb-0">
              <div className="mb-6">
                <h2 className="text-4xl font-semibold mb-4 text-black">
                  Before Your Appointment (Pre-Care)
                </h2>
                <ul className="list-disc list-inside leading-loose">
                  {rejuviPreCare.map((instruction, index) => (
                    <li key={index} className="mb-2">
                      {instruction}
                    </li>
                  ))}
                </ul>
                <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                  <p className="text-base text-gray-800">
                    <strong> Tip:</strong> Arrive with clean, product-free skin. If you're prone to 
                    post-treatment irritation, bring a loose hat or scarf to protect the area from sun and friction.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-4 p-6 md:mx-12 mx-4">
        <h2 className="my-4 text-4xl font-semibold text-black">
          Right After Treatment (What's Normal)
        </h2>
        <ul className="list-disc list-inside mb-6 leading-loose">
          {rejuviRightAfterTreatment.map((instruction, index) => (
            <li key={index} className="mb-2">
              {instruction}
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-gray-50 py-12">
        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl text-gray-800 mb-4">Healing Timeline</h2>
            <p className="text-xl text-gray-600">Your Journey to Recovery</p>
            <div className="w-24 h-1 bg-primary mx-auto mt-4"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="mb-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                <div style={{background: 'linear-gradient(to right, #b0c4b1, #e3d5ca)'}} className="p-3">
                  <h3 className="text-2xl font-bold text-gray-700 text-center">
                    First 72 Hours (Days 0–3)
                  </h3>
                  <p className="text-gray-600 text-center text-sm mt-1">Critical initial care</p>
                </div>
                <div className="p-5">
                  <ul className="space-y-2">
                    {rejuviFirst72Hours.map((instruction, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                        <p className="text-gray-700 text-base">{instruction}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                <div style={{background: 'linear-gradient(to right, #e3d5ca, #ffe5ec)'}} className="p-3">
                  <h3 className="text-2xl font-bold text-gray-700 text-center">
                    Days 4–7
                  </h3>
                  <p className="text-gray-600 text-center text-sm mt-1">Continued healing phase</p>
                </div>
                <div className="p-5">
                  <ul className="space-y-2">
                    {rejuviDays4to7.map((instruction, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                        <p className="text-gray-700 text-base">{instruction}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                <div style={{background: 'linear-gradient(to right, #ffe5ec, #c9ada7)'}} className="p-3">
                  <h3 className="text-2xl font-bold text-gray-700 text-center">
                    Days 8–14
                  </h3>
                  <p className="text-gray-600 text-center text-sm mt-1">Recovery and stabilization</p>
                </div>
                <div className="p-5">
                  <ul className="space-y-2">
                    {rejuviDays8to14.map((instruction, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                        <p className="text-gray-700 text-base">{instruction}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                <div style={{background: 'linear-gradient(to right, #c9ada7, #e0afa0)'}} className="p-3">
                  <h3 className="text-2xl font-bold text-gray-700 text-center">
                    Weeks 3–4+
                  </h3>
                  <p className="text-gray-600 text-center text-sm mt-1">Long-term maintenance</p>
                </div>
                <div className="p-5">
                  <ul className="space-y-2">
                    {rejuviWeeks3Plus.map((instruction, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2"></div>
                        <p className="text-gray-700 text-base">{instruction}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg">
          <h2 className="text-4xl mb-4 text-black">
            Extra Do's & Don'ts (Throughout Healing)
          </h2>
          <ul className="list-disc list-inside mb-6 leading-loose">
            {rejuviDosDonts.map((instruction, index) => (
              <li key={index} className="mb-2">
                {instruction}
              </li>
            ))}
          </ul>
          <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Important Notes:</h3>
            <p className="text-base text-gray-800 mb-2">
              Healing can vary with tattoo age, color, depth, location, and skin type—set expectations 
              that some clients need additional sessions.
            </p>
            <p className="text-base text-gray-800">
              <strong>Remember:</strong> Rejuvi is non-laser and uses controlled crusting to extract pigment; 
              the crust is part of the process, not a complication.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejuviTattooRemovalCare;